var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"dark":"","height":_vm.computeHeight ? _vm.computedHeight : _vm.height,"hide-delimiters":"","show-arrows-on-hover":!_vm.isMobile},scopedSlots:_vm._u([{key:"prev",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v("mdi-chevron-left")])]}},{key:"next",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v("mdi-chevron-right")])]}}])},_vm._l((_vm.photos),function(photo,i){return _c('v-carousel-item',{key:i,class:_vm.padding,attrs:{"src":photo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }